enum ValidationResultType {
  NotSet = 0,
  Valid = 1,
  NotValid = 2,
  Error = 3,
  InvalidCode = 4
}

export default ValidationResultType;
